import ApiService from './api';

// Please read the docu:
// https://github.com/knowhereto/moin-hub/wiki/User-Tracking

/** Tracking event payload; `name` is filled in by the track* helper methods. */
interface TrackingBody {
  /** Bot the event belongs to — required, tracking is skipped without it */
  botId?: string;
  /** Event name (one of trackingNameTypes); set by the specific track* helpers */
  name?: string;
  /** Arbitrary event properties per the User-Tracking wiki (source, type, etc.) */
  [key: string]: any;
}

const trackingNameTypes = {
  newIntent: 'new-intent',
  menu: 'menu',
  welcomeView: 'welcome-view',
  copyPaste: 'copy-paste',
  keywords: 'keywords',
  settings: 'settings',
  settingsRoles: 'settings-roles',
  settingsPrivacy: 'settings-privacy',
  settingsArchive: 'settings-archive',
  settingsFiles: 'settings-files',
  teasers: 'teasers',
  intentsView: 'intents-view',
  statsView: 'statistics',
  channelManagement: 'channel-management',
} as const;

const TrackingService = {
  async track(body: TrackingBody): Promise<any> {

    if (!body.botId) {
      return false;
    }

    try {
      const response = await ApiService.post(
        '/schaltzentrale/tracking/' + body.botId,
        body
      );
      return response.data;
    } catch (error) {
      return false;
    }
  },
  trackNewIntent(body: TrackingBody): void {
    body.name = trackingNameTypes.newIntent;
    this.track(body);
  },
  trackMenu(body: TrackingBody): void {
    body.name = trackingNameTypes.menu;
    this.track(body);
  },
  trackWelcomeView(body: TrackingBody): void {
    body.name = trackingNameTypes.welcomeView;
    this.track(body);
  },
  trackCopyPaste(body: TrackingBody): void {
    body.name = trackingNameTypes.copyPaste;
    this.track(body);
  },
  trackKeywords(body: TrackingBody): void {
    body.name = trackingNameTypes.keywords;
    this.track(body);
  },
  trackSettings(body: TrackingBody): void {
    body.name = trackingNameTypes.settings;
    this.track(body);
  },
  trackSettingsRoles(body: TrackingBody): void {
    body.name = trackingNameTypes.settingsRoles;
    this.track(body);
  },
  trackSettingsPrivacy(body: TrackingBody): void {
    body.name = trackingNameTypes.settingsPrivacy;
    this.track(body);
  },
  trackSettingsArchive(body: TrackingBody): void {
    body.name = trackingNameTypes.settingsArchive;
    this.track(body);
  },
  trackSettingsFiles(body: TrackingBody): void {
    body.name = trackingNameTypes.settingsFiles;
    this.track(body);
  },
  trackTeasers(body: TrackingBody): void {
    body.name = trackingNameTypes.teasers;
    this.track(body);
  },
  trackIntentsView(body: TrackingBody): void {
    body.name = trackingNameTypes.intentsView;
    this.track(body);
  },
  trackStatsView(body: TrackingBody): void {
    body.name = trackingNameTypes.statsView;
    this.track(body);
  },
  trackChannelManagement(body: TrackingBody): void {
    body.name = trackingNameTypes.channelManagement;
    this.track(body);
  },
};

export default TrackingService;

export { TrackingService };
